import * as Sentry from '@sentry/react'
import { env } from '@/shared/config/env'

export function initSentry() {
  const dsn = env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
  })
}
